<template>
    <div class="container card">
        <div class="d-flex justify-content-between align-items-center">
            <h1>Locaties</h1>
            <div class="row">
                <div class="col">
                    <div class="" @click="showCreateForm=true" style="cursor: pointer;">
                        <button class="btn btn-secondary btn-sm rounded-circle btn-icon-only float-right" v-tooltip="'Toevoegen'">
                            <icon name="plus"></icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <table v-if="locationsData?.data?.length > 0" class="table table-striped table-hover">
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Naam</th>
                    <th>Korte naam</th>
                    <th>Type</th>
                    <th>Plechtigheden (<strong>{{ totalCeremonies }}</strong>)</th>
                    <th>Company</th>
                    <ordering
                        @change="getLocations"
                        v-model="order"
                        field="created_at"
                        tag="th"
                        class="text-right"
                    >
                        Aangemaakt op
                    </ordering>
                    <th class="text-right">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="location in locationsData.data" :key="location.id">
                    <td>{{ location.id }}</td>
                    <td>
                        {{ location.name }}

                        <span v-if="location.deleted_at" class="badge badge-danger" v-tooltip="'Deze locatie is verwijderd'">
                            <icon name="exclamation" scale="0.8" class="m-0" style="fill: #fff" />
                        </span>
                    </td>
                    <td>{{ location.short_name }}</td>
                    <td>{{ location.type === 1 ? 'Normaal' : '2GO' }}</td>
                    <td
                        @click="showCeremoniesModalToggle(location)"
                        :style="location.total_ceremonies > 0 ? 'cursor: pointer;color: blue; text-decoration: underline;' : ''"
                    >
                        {{ location.total_ceremonies }}
                    </td>
                    <td>{{ location.company.name }}</td>
                    <td class="text-right">{{ formatDateTime(location.created_at) }}</td>
                    <td class="text-right">
                        <button v-if="!location.deleted_at" class="btn btn-xs rounded-pill btn-primary"
                                @click="editLocation(location)" v-tooltip="'Bewerken'">
                            <icon name="pencil-alt" scale="0.8"></icon>
                        </button>
                        <button v-if="!location.deleted_at" class="btn btn-xs rounded-pill btn-danger"
                                @click="deleteLocation(location)" v-tooltip="'Verwijderen'">
                            <icon name="trash" scale="0.8"></icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-else class="text-center alert alert-warning">
            <p class="mb-0">Geen locaties gevonden (voeg of verwijder filters toe voor resultaten).</p>
        </div>

        <Pagination v-if="locationsData" :pagination="locationsData" @change="getLocations" class="mt-2 mb-2" />
        <!-- Delete Confirmation Modal -->
        <modal :show="showDeleteModal" @close="closeDeleteModal">
            <template #header>
                <div class="modal-header">
                    <h5 class="modal-title">Delete location</h5>
                    <button type="button" class="close" @click="closeDeleteModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </template>
            <template #body>
                <div class="modal-body">
                    Are you sure you want to delete this location?
                </div>
            </template>
            <template #footer>
                <button type="button" class="btn btn-secondary" @click="closeDeleteModal">Cancel</button>
                <button type="button" class="btn btn-danger" @click="confirmLocation">Delete</button>
            </template>
        </modal>
        <!-- Edit Location Modal -->
        <modal :show="showEditForm" @close="closeEditForm" custom_content_css="width:1000px;" custom_dialog_css="justify-content: center; display:grid">
            <template #header>
                <div class="modal-header">
                    <h5 class="modal-title">Edit location</h5>
                    <button type="button" class="close" @click="closeEditForm">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </template>
            <template #body>
                <div class="modal-body">
                    <form @submit.prevent="updateLocation" class="needs-validation" novalidate>
                        <div class="row">
                            <div v-for="(value, key, index) in selectedLocation" :key="key" v-if="!notShownFields.includes(key)" class="form-group col-md-6 pr-5">
                                <label :for="key" class="form-label">{{ key }}
                                    <icon name="question-circle" v-tooltip="getTooltip(key)" />
                                    <span v-if="isRequiredIndication(key)" class="text-danger">*</span>
                                </label>
                                <div v-if="(typeof value === 'boolean')">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" :id="key" v-model="selectedLocation[key]">
                                        <label class="custom-control-label" :for="key"></label>
                                    </div>
                                </div>
                                <div v-else>
                                    <input class="form-control" type="text" :id="key" v-model="selectedLocation[key]">
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </template>
            <template #footer>
                <button type="button" class="btn btn-secondary" @click="closeEditForm">Cancel</button>
                <button type="button" class="btn btn-primary" @click="updateLocation">Save</button>
            </template>
        </modal>
        <!-- Create Location Modal -->
        <modal :show="showCreateForm" @close="closeCreateForm" custom_content_css="width:1000px;" custom_dialog_css="justify-content: center; display:grid">
            <template #header>
                <div class="modal-header">
                    <h5 class="modal-title">Create location</h5>
                    <button type="button" class="close" @click="closeCreateForm">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </template>
            <template #body>
                <div class="modal-body">
                    <form @submit.prevent="createLocation" class="needs-validation" novalidate>
                        <div class="row">
                            <div v-for="(value, key, index) in newLocation" :key="key" class="form-group col-md-6 pr-5" v-if="!notShownFields.includes(key)">
                                <label :for="key" class="form-label">{{ key }}
                                    <icon name="question-circle" v-tooltip="getTooltip(key)" />
                                    <span v-if="isRequiredIndication(key)" class="text-danger">*</span>
                                </label>
                                <div v-if="typeof value === 'boolean' ">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" :id="key" v-model="newLocation[key]">
                                        <label class="custom-control-label" :for="key"></label>
                                    </div>
                                </div>
                                <div v-else>
                                    <input class="form-control" type="text" :id="key" v-model="newLocation[key]">
                                </div>
                            </div>
                        </div>

                        <div v-if="Object.keys(errors).length > 0" class="alert alert-danger mt-3">
                            <p class="mb-1"><strong>Foutmeldingen</strong></p>
                            <ul class="mb-0 pl-3">
                                <li v-for="(fieldErrors, field) in errors" :key="field">
                                    <span v-for="(error, index) in fieldErrors" :key="index">{{ error }}</span>
                                </li>
                            </ul>
                        </div>
                    </form>
                </div>
            </template>
            <template #footer>
                <button type="button" class="btn btn-secondary" @click="closeCreateForm">Cancel</button>
                <button type="button" class="btn btn-primary" @click="createLocation">Create</button>
            </template>
        </modal>

        <CeremoniesModal
            :show="showCeremoniesModal"
            :entity-id="ceremoniesModalEntityId"
            entity-type="locations"
            :entityName="ceremoniesModalEntityName"
            :filters="filters"
            @close="closeCeremoniesModal"
        />
    </div>
</template>

<script>
    import Modal from '../../../components/Modal.vue';
    import Pagination from '../../../components/Pagination.vue';
    import Ordering from '../../../components/Ordering.vue';
    import UtilMixin from '../../mixins/UtilMixin.vue';
    import CeremoniesModal from "./Modals/CeremoniesModal.vue";
    import {notifyError} from "../../../utils/notify";

    export default {
        components: {CeremoniesModal, Modal, Pagination, Ordering },

        mixins: [
            UtilMixin,
        ],

        props: {
            locations: {
                type: Object,
                default: () => {
                },
            },
            ordering: {
                type: String,
                required: true,
            },
            filters: {
                type: Object,
                default: null,
            },
        },

        watch: {
            locations: {
                handler(newValue) {
                    this.locationsData = newValue.locations;
                    this.totalCeremonies = newValue.total_ceremonies;
                },
                immediate: true,
                deep: true,
            },
            ordering: {
                handler(newValue) {
                    this.order = newValue;
                },
            },
        },

        computed: {
            booleanToNumber: {
                get() {
                    let result = {};
                    for (let key in this.selectedLocation) {
                        let value = this.selectedLocation[key];
                        if (typeof value === 'boolean') {
                            result[key] = value ? 1 : 0;
                        }
                    }
                    return result;
                },
                set(newValue) {
                    for (let key in newValue) {
                        this.selectedLocation[key] = newValue[key] === 1;
                    }
                },
            },
        },


        data() {
            return {
                locationsData: {},
                totalCeremonies: 0,
                selectedLocation: null,
                showEditForm: false,
                showDeleteModal: false,
                order: this.ordering,
                notShownFields: ['created_at', 'updated_at', 'deleted_at', 'id', 'company', 'total_ceremonies'],
                newLocation: {
                    name: '',
                    tcp_name: '',
                    short_name: '',
                    company_id: null,
                    aspect_ratio: '16by9',
                    livestream_channel_id: null,
                    livestream_platform_url: '',
                    livestream_platform_access_token: '',
                    livestream_download_reminders: false,
                    livestream_send_invite: false,
                },
                showCreateForm: false,
                showCeremoniesModal: false,
                ceremoniesModalEntityId: null,
                ceremoniesModalEntityName: '',
                locationCeremonies: {},
                errors: {},
            };
        },

        methods: {
            // Tooltip
            getTooltip(key) {
                const tooltips = {
                    name: 'De naam van de locatie',
                    tcp_name: 'De naam van de locatie in het TCP',
                    short_name: 'De korte naam van de locatie',
                    created_at: 'De datum waarop de locatieis aangemaakt',
                    updated_at: 'De datum waarop de locatieis aangepast',
                    company_id: 'Het bedrijf waar de locatie bij hoort',
                    aspect_ratio: 'De standaard aspect ratio van de locatie',
                    livestream_channel_id: 'Het channel ID van de livestream. Deze vind je terug in Streameasy',
                    livestream_platform_url: 'De URL van het livestream platform (domain.uitvaart-online.nu)',
                    livestream_platform_access_token: 'Het access token van het livestream platform. Deze maak je aan bij Streameasy',
                    livestream_download_reminders: 'Of er herinneringen moeten worden gestuurd voor het downloaden van de livestream',
                    livestream_send_invite: 'De standaard waarde voor het uitnodigen van een persoon voor een livestream (JA/NEE)',
                    type: 'Het type van de locatie, 1 = normaal, 2 = lite',
                };
                return tooltips[key] || '';
            },

            //     Delete Location
            closeDeleteModal() {
                this.showDeleteModal = false;
            },
            async confirmLocation() {
                this.$emit('loading', true);

                const locationName = this.selectedLocation.name;
                try {
                    await this.$http.delete(`/api/admin/locations/${this.selectedLocation.id}`);
                    this.locationsData = {
                        ...this.locationsData,
                        data: this.locationsData.data.filter(location => location.id !== this.selectedLocation.id),
                    };
                    this.selectedLocation = null;
                    this.showDeleteModal = false;
                    this.$notify({
                        group: 'default',
                        title: 'Locatie verwijderd',
                        text: `De Locatie ${locationName} is successvol verwijderd`,
                        type: 'success',
                        duration: 2000,
                        position: 'top center',
                    });
                } catch (error) {
                    console.error(error);
                    this.$notify({
                        group: 'default',
                        title: 'Locatie verwijderd',
                        text: `De Locatie ${locationName} is niet verwijderd`,
                        type: 'error',
                        duration: 2000,
                        position: 'top center',
                    });
                } finally {
                    this.$emit('loading', false);
                }
            },
            deleteLocation(location) {
                this.selectedLocation = { ...location };
                this.showDeleteModal = true;
            },

            // Edit location
            async editLocation(location) {
                this.selectedLocation = { ...location };
                this.showEditForm = true;
            },
            closeEditForm() {
                this.showEditForm = false;
            },
            async updateLocation() {
                this.$emit('loading', true);

                const locationName = this.selectedLocation.name;
                try {
                    await this.$http.put(`/api/admin/locations/${this.selectedLocation.id}`, this.selectedLocation);
                    const index = this.locationsData.data.findIndex(location => location.id === this.selectedLocation.id);
                    this.locationsData.data[index] = { ...this.selectedLocation };
                    this.selectedLocation = null;
                    this.showEditForm = false;
                    this.$notify({
                        group: 'default',
                        title: 'Locatie aangepast',
                        text: `De locatie ${locationName} is successvol aangepast`,
                        type: 'success',
                        duration: 2000,
                        position: 'top center',
                    });
                } catch (error) {
                    console.error(error);
                    this.$notify({
                        group: 'default',
                        title: 'locatie aangepast',
                        text: `De locatie ${locationName} is niet aangepast`,
                        type: 'error',
                        duration: 2000,
                        position: 'top center',
                    });
                } finally {
                    this.$emit('loading', false);
                }
            },

            // Create location
            isRequiredIndication(key) {
                const requiredFields = ['company_id', 'name', 'hash', 'hostname', 'websocket_hostname', 'mail_from_address', 'mail_from_name', 'set_duration_enabled', 'back_confirmation', 'block_titles', 'skip_repeat_for_duration_count'];
                return requiredFields.includes(key);
            },

            getLocations(page = undefined) {
                this.$emit('getLocations', { page: page || this.locationsData?.current_page || 1, order: this.order });
            },
            closeCreateForm() {
                this.showCreateForm = false;
                this.errors = {};
            },
            async createLocation() {
                this.$emit('loading', true);

                try {
                    const response = await this.$http.post('/api/admin/locations/', this.newLocation);
                    this.locationsData.data.unshift(response.data);
                    this.newLocation = {}; // Reset the form
                    this.showCreateForm = false;
                    this.$notify({
                        group: 'default',
                        title: 'Locatie aanmaken',
                        text: `De locatie is successvol aangemaakt`,
                        type: 'success',
                        duration: 2000,
                        position: 'top center',
                    });
                    this.$emit('locationCreated', response.data);
                } catch (error) {
                    this.errors = {};

                    if (error.response && error.response.data && error.response.data.errors) {
                        this.errors = error.response.data.errors;
                    }

                    this.$notify({
                        group: 'default',
                        title: 'Locatie aanmaken',
                        text: `De locatie kon niet worden aangemaakt`,
                        type: 'error',
                        duration: 2000,
                        position: 'top center',
                    });
                } finally {
                    this.$emit('loading', false);
                }
            },
            closeCeremoniesModal() {
                this.ceremoniesModalEntityId = null;
                this.ceremoniesModalEntityName = '';
                this.showCeremoniesModal = false;
            },
            showCeremoniesModalToggle(location) {
                this.showCeremoniesModal = true;
                this.ceremoniesModalEntityId = location.id;
                this.ceremoniesModalEntityName = location.name;
            },
        },

        mounted() {
            this.getLocations();
        },
    };
</script>
